export default "__VITE_ASSET__BjSYztWU__"